import { useState } from 'react';
import { Cloud, CloudOff } from 'lucide-react';
import { useSession } from '../../lib/useAuth';
import { isCloudConfigured } from '../../lib/pocketbaseClient';
import { AuthSheet } from './AuthSheet';

/**
 * Kompakter Cloud-Sync-Status-Button fuer den Header.
 * - Cloud nicht konfiguriert: dezenter, neutraler Button (oeffnet Sheet mit Hinweis)
 * - Eingeloggt: gefuellte Cloud, gruener Punkt
 * - Nicht eingeloggt (aber konfiguriert): umrandete Cloud, "Anmelden"-Label
 */
export function AuthButton(): JSX.Element {
  const session = useSession();
  const [open, setOpen] = useState(false);
  const cloudOk = isCloudConfigured();

  const label = !cloudOk
    ? 'Cloud-Sync (lokal)'
    : session
      ? 'Cloud-Sync aktiv'
      : 'Anmelden';
  const Icon = cloudOk ? Cloud : CloudOff;

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        aria-label={label}
        className="inline-flex h-9 items-center gap-1.5 rounded-full border border-zinc-200 bg-white px-3 text-xs font-semibold text-zinc-700 active:bg-zinc-100 focus-visible:outline-2 focus-visible:outline-emerald-500 focus-visible:outline-offset-2"
      >
        <Icon
          aria-hidden="true"
          className={
            session ? 'size-4 text-emerald-600' : 'size-4 text-zinc-500'
          }
        />
        <span className="hidden sm:inline">{label}</span>
        {session ? (
          <span
            aria-hidden="true"
            className="inline-block size-1.5 rounded-full bg-emerald-500"
          />
        ) : null}
      </button>
      {open ? <AuthSheet onClose={() => setOpen(false)} /> : null}
    </>
  );
}
